import { useState, useEffect } from 'react'

import { actionButton as copy } from '@/features/user/your-practice/documents/lib/copyConstants'
import {
  destroySingleUserDocument,
  UserDocument,
} from '@/features/user/your-practice/documents/lib/userDocuments.slice'

// UI
import { Button, Dialog } from '@/ui'
import { useAppDispatch } from '@/utils/typeHelpers'

export const DeleteStatement = ({
  document,
  close,
  updateDocumentStatements,
  open,
}: {
  document: UserDocument | undefined
  close: () => void
  updateDocumentStatements: () => void
  open: boolean
}) => {
  const [loading, setLoading] = useState(false)
  const [customText, setCustomText] = useState<string>('')
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (document) {
      setCustomText(copy.dynamic.confirmContent(document))
    }
  }, [document, open])

  const onConfirm = async () => {
    if (loading || !document) return

    setLoading(true)
    await destroySingleUserDocument(document.id)(dispatch)
    updateDocumentStatements()
    setLoading(false)
    close()
  }

  return (
    <Dialog open={open} onOpenChange={close}>
      <Dialog.Content className="space-y-4">
        <div>{customText}</div>
        <Dialog.Footer>
          <Dialog.Close asChild>
            <Button variant="secondary">Cancel</Button>
          </Dialog.Close>
          <Button variant="danger" onClick={onConfirm} loading={loading}>
            {loading
              ? copy.static.confirmButtonLoadingText
              : copy.static.confirmButtonNotLoadingText}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
